module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-formTable">\r\n  <div class="phx-formErrors ui-state-error"></div>\r\n  <div>\r\n    <div class="phx-lanceetat-details-header-text">\r\n      <label class="phx-lanceetat-header-selected cw-titre"></label>\r\n    </div>\r\n  </div>\r\n</div>';
}
return __p;
};
